<fieldset *ngIf="displayAccessories()" class="characteristicsFieldset">
  <legend class="shGreenTitle">
    <div class="row align-items-center">
    <div class="col-7"><span translate>{{title}}</span></div>
    <div class="col-5">
      <ng-template #accessInfoTemplate><div [innerHtml]="accessInfo | translate"></div></ng-template>
      <span *ngIf="accessInfo" class="se-icons font-param access-info" [tooltip]="accessInfoTemplate"
            placement="left" container="body" aria-hidden="true">information_circle</span>
      <div (click)="changeDisplay()">
        <span [tooltip]="'T_COLLAPSE_TOOLTIP' | translate" *ngIf="display" class="se-icons arrow" translate>arrow2_up</span>
        <span [tooltip]="'T_EXPAND_TOOLTIP' | translate" *ngIf="!display" class="se-icons arrow">arrow2_down</span>
      </div>
    </div>
    </div> <!-- /row -->
  </legend>
  <div *ngIf="display" [@fadeInOut] class="form-horizontal">
    <ng-container *ngFor="let element of getElementsSorted(); let isLast = last;" >
      <div class="form-group row align-items-center" *ngIf="!noValueOrHidden(element)" (click)="isClickOnLast(isLast)">
        <div class="col-5">
          <!-- LABEL -->
          <label [for]="element.id" class="control-label col-form-label"
                 [ngClass]="{ 'required-red-asterisk' : element.required && (!element.options || element.options.length >= 2)}"
                 translate>{{element.label}}
          </label>

          <!-- TOOLTIP TEMPLATE -->
          <ng-template #tooltipTemplate>
            <div [innerHTML]="element.information | translate" class="tooltip-field"></div>
          </ng-template>

          <!-- INFO PELLET WITH TOOLTIP -->
          <span *ngIf="element.information" class="se-icons brand-information" container="body"
                [tooltip]="tooltipTemplate" placement="right">information_circle</span>
        </div>
        <div class="col-5">
            <div [tooltip]="element.tooltip | translate" placement="right"
              [adaptivePosition]="false" containerClass="characteristic-tooltip"
              container="body">

            <!-- SELECT -->
            <div *ngIf="!isOnlyOneAvailableOption(element)">
              <select *ngIf="isHtmlElement(element, 'select') || !!element.packageOptions" class="form-select" [id]="element.id"
                      [ngClass]="{'hide-select-arrow': element.chooseValue}"
                      [required]="element.required" [disabled]="element.disabled || readOnly || element.chooseValue"
                      (change)="onChangeValue($event.target.value, element)">
                <option *ngIf="!valueAlreadyExists(element)" disabled selected
                        [value]=" "></option>
                <ng-container *ngFor="let val of getElementOptionsSorted(element)">
                  <option [selected]="val.selected" *ngIf="!val.disabled" [value]="val.value" [ngClass]="{'highlighted-selected-option': val.selected}" translate>{{val.value}}</option>
                </ng-container>
                <ng-container *ngFor="let val of element.packageOptions">
                  <option [selected]="val.selected" [value]="val.id" [ngClass]="{'highlighted-selected-option': val.selected}">{{val.name}}</option>
                </ng-container>
              </select>

              <!-- MULTISELECT -->
              <p-multiSelect #ms *ngIf="isHtmlElement(element, 'multiSelect')"
                             [options]="element.multiOptions"
                             [(ngModel)]="chosenOptionsMultiselectModel[element.id]"
                             optionLabel="name"
                             optionValue="id"
                             [disabled]="readOnly"
                             [showHeader]="false"
                             (onChange)="onMultiSelectChange($event, element, ms)"
                             (onPanelHide)="onMultiSelectPanelHide(element)">
              </p-multiSelect>


              <div id="alert_placeholder_{{element.label}}" class="alert-div">
                <div *ngIf="element.isOnAlert" id="alertDiv_{{element.label}}" class="alert  alert-danger">
                  <span translate>{{element.alertMessage}}</span></div>
              </div>
            </div>

            <input *ngIf="isOnlyOneAvailableOption(element)"
                   type="text" disabled class="form-control" [id]="element.id"
                   [value]="getOnlyAvailableOption(element).value.toString() | translate">
          </div>
        </div>

        <!-- UNIT -->
        <div class="col-1">
          <span *ngIf="element.unit" translate>{{element.unit}}</span>
        </div>

        <!-- RESET -->
        <div class="col-1" *ngIf="currentItemct?.status !== Status.ordered">
          <button class="btn btn-default-grey-background" *ngIf="isHtmlElement(element, 'multiSelect') ? chosenOptionsMultiselectModel[element.id]?.length > 0 : element.chooseValue" (click)="resetValue(element)" translate>T_RESET_BUTTON</button>
        </div>

      </div>
    </ng-container>

  </div>
</fieldset>
